import {Observable}   from 'rxjs';
import {filter, take} from 'rxjs/operators';

import LocalStorage from '../../LocalStorage/LocalStorage';

const createLocalStorageVolumeStream = (
    localStorageUpdate$: Observable<LocalStorage>
): Observable<LocalStorage> =>
    localStorageUpdate$
        .pipe(
            // Read the first emission from local storage only
            take(1),
            // Filter out emissions where the volume has not been set previously
            filter(({volumeLevel, volumeMuted}) => volumeLevel !== null && volumeMuted !== null)
        );

export default createLocalStorageVolumeStream;